export default __webpack_public_path__ + "static/media/1992.fa07d099.png";